import { tableStyles } from '../styles';

export function SkeletonTable() {
    const skeletonRows = Array.from({ length: 20 });
    const skeletonColumns = Array.from({ length: 20 });

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ ...tableStyles.container, overflow: 'hidden', flex: 1 }}>
                <div style={tableStyles.tableWrapper}>
                    {/* Header Skeleton */}
                    <div style={{ display: 'flex' }}>
                        <div style={{ ...tableStyles.headerCell, width: '200px' }}>
                            <div
                                style={{
                                    width: '80%',
                                    height: '16px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '4px',
                                    animation: 'pulse 1.5s ease-in-out infinite',
                                }}
                            />
                        </div>
                        {skeletonColumns.map((_, idx) => (
                            <div key={idx} style={{ ...tableStyles.headerCell, flex: 1 }}>
                                <div
                                    style={{
                                        width: '60%',
                                        height: '16px',
                                        backgroundColor: '#e0e0e0',
                                        borderRadius: '4px',
                                        margin: '0 auto',
                                        animation: 'pulse 1.5s ease-in-out infinite',
                                        animationDelay: `${idx * 0.1}s`,
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                    {skeletonRows.map((_, rowIdx) => (
                        <div
                            key={rowIdx}
                            style={{
                                display: 'flex',
                                height: '40px',
                                borderBottom: '1px solid #e0e0e0',
                            }}
                        >
                            <div
                                style={{
                                    width: '200px',
                                    padding: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        width: '70%',
                                        height: '14px',
                                        backgroundColor: '#e0e0e0',
                                        borderRadius: '4px',
                                        animation: 'pulse 1.5s ease-in-out infinite',
                                        animationDelay: `${rowIdx * 0.05}s`,
                                    }}
                                />
                            </div>
                            {skeletonColumns.map((_, colIdx) => (
                                <div
                                    key={colIdx}
                                    style={{
                                        flex: 1,
                                        padding: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '50%',
                                            height: '14px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '4px',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                            animationDelay: `${(rowIdx * 0.05) + (colIdx * 0.02)}s`,
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
        </div>
    );
}
